import React, { useEffect, useState, useRef } from "react";
import SearchIcon from "assets/icons/search-icon.png";
import ResendIcon from "assets/svgIcons/ResendIcon";
import ClubToCarMsgIcon from "assets/svgIcons/ClubToCarMsg";
import CarToClubMsgIcon from "assets/svgIcons/CarToClubMsg";
import CarToMarshalCarMsg from "assets/svgIcons/CarToMarshalMsg";
import CarToAllMsg from "assets/svgIcons/CarToAllMsg";
import ExclamationMarkIcon from "assets/svgIcons/ExclamationMarkIconWithBorder";
import FilterFlagIcon from "assets/svgIcons/FlagIconWithBorder";
import ExclamationMarkTrangel from "assets/svgIcons/ExclamationMarkTrangelIconWithBorder";
import BatteryIcon from "assets/svgIcons/BatteryIconWithBorder";
import MarshalsCarIcon from "assets/svgIcons/CarType/Marshals";
import TimeIcon from "assets/svgIcons/TimeIcon";
import HomeIcon from "assets/svgIcons/HomeIcon";
import StarIcon from "assets/svgIcons/StarIcon";
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import IconButton from "@mui/material/IconButton";
import ThreeDotIcon from "assets/svgIcons/ThreeDotsIcon";
import { getMessagesHistory } from "redux/reduxToolkitServices/_commonApiCalls/api";
import {
  HistoryContainer,
  Header,
  SearchWrapper,
  HistoryTableInnerSection,
} from "pages/Messages/History/HistoryStyled";
import { useDispatch, useSelector } from "react-redux";
import {
  COMMON_SERVICES,
  headersConfigData
} from "redux/reduxToolkitServices/_commonServices/commonServices";
import { TextField, Tooltip } from "@mui/material";
import _ from "lodash";
import { Stack } from "@mui/system";
import moment from "moment";
import { DataGrid } from "@mui/x-data-grid";
import { useHookstate } from "@hookstate/core";
import {
  SITEID_GLOBAL_STATE,
  UPDATED_CAR_DATA_STATE,
} from "../../../globalStore/globalStore";
import {
  TableContainer,
  BodyWrapper,
  DateRangePickerWrapper,
  MobileHeader,
} from "assets/css/globle";
import { useTranslation } from "react-i18next";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorIcon from "@mui/icons-material/Error";
import Battery0BarIcon from "@mui/icons-material/Battery0Bar";
import SportsScoreIcon from "@mui/icons-material/SportsScore";
import { featureKey, isUserAdmin, isUserSupport, getFeatureSetOption, getFeaturesList, } from "constant";
import MembercarIcon from "assets/svgIcons/CarType/MembercarIcon";
import DiagnosticsIcon from "assets/svgIcons/MsgNotificationIcons/diagnosticsIcon";
import { validateCarType } from "_helperFunctions/validateCarType";
import TodayDateActionBar from "commonComponents/Calendar/todayDateActionBar";
export const History = () => {
  const { t } = useTranslation();

  const [threeDotState, setThreeDotState] = useState(false);
  const outerW = useRef(null);
  const innerW = useRef(null);
  const { updatedCarData } = useHookstate(UPDATED_CAR_DATA_STATE);

  let filteredCount = 0;

  useEffect(() => {
    if (outerW.current?.clientWidth === null) {
      return;
    }
  });

  useEffect(() => {
    if (innerW.current?.clientWidth === null) {
      return;
    }
  });

  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

  const dispatch = useDispatch();

  const { siteSettingsData, getUserRole } = useSelector((state) => state.commonReducers) || [];
  const [searchInputValue, setSearchInputValue] = useState("");
  const [showToCar, setShowToCar] = useState(true);
  const [showFromCar, setShowFromCar] = useState(true);
  const [showForwarded, setShowForwarded] = useState(true);
  const [showBroadcast, setShowBroadcast] = useState(true);
  const [showDiagnostics, setShowDiagnostics] = useState(false);
  const [showMore, setShowMore] = useState({});
  const [showBatteryNotifications, setShowBatteryNotifications] = useState(false);
  const [showMaxHolesNotifications, setShowMaxHolesNotifications] = useState(false);
  const [showAZNotifications, setShowAZNotifications] = useState(false);
  const [showCritFaultNotifications, setShowCritFaultNotifications] = useState(false);
  const enableMemberCar = isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role) || !getFeatureSetOption(siteSettingsData?.Features, getFeaturesList().member_cars);
  const [showMemberCars, setShowMemberCars] = useState(enableMemberCar);
  const [messagesHistoryDataState, setMessagesHistoryData] = useState([]);
  const [messageStatus, setMessageStatus] = useState(false);
  const [messageTextFilter, setMessageTextFilter] = useState("");
  let carsFilter = "";

  const [startDate, setStartDate] = useState(
    localStorage.getItem("startDate")
      ? new Date(localStorage.getItem("startDate"))
      : new Date()
  );

  const [endDate, setEndDate] = useState(
    localStorage.getItem("endDate")
      ? new Date(localStorage.getItem("endDate"))
      : new Date()
  );

  const decodeHtml = (html) => {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  }

  useEffect(() => {
    let storedStart = localStorage.getItem("startDate");
    let storedEnd = localStorage.getItem("endDate");

    const today = new Date();

    if (!storedStart) {
      localStorage.setItem("startDate", today);
      setStartDate(today);
    }

    if (!storedEnd) {
      localStorage.setItem("endDate", today);
      setEndDate(today);
    }
  }, []);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
    refresh();
  }, [siteId.get()]);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getUserNameAndRoles());
  }, []);

  useEffect(() => {
    if (startDate > endDate) setEndDate(startDate);
  }, [startDate]);

  useEffect(() => {
    if (startDate > endDate) setStartDate(endDate);
  }, [endDate]);

  useEffect(() => {
    refresh();
  }, [
    showDiagnostics,
    showBatteryNotifications,
    showMaxHolesNotifications,
    showAZNotifications,
    showCritFaultNotifications,
  ]);

  let messagesList = messagesHistoryDataState?.length > 0 && messagesHistoryDataState?.filter((item) => {
    if (searchInputValue === "") {
      return true; // Include all items when searchInputValue is empty
    } else if (
      item?.CarNum.toString()
        .toLowerCase()
        .includes(searchInputValue.toLowerCase())
    ) {
      return true; // Include the item if it matches the search condition
    } else {
      return false; // Exclude the item otherwise
    }
  })
    .map((item) => ({
      ...item,
      id: item.Id,
      received: moment(item.Created).unix(),
      lastUpdated: item.LastUpdated,
      car: item.CarNum,
      text: item.Text,
      response: item.Response,
      hole: item.Hole,
      status: item.Delivered,
      sentBy: item.SentBy,
    }));

  let messageTypes = {
    Text: 0,
    ActionZone: 1,
    CriticalFault: 2,
    LowBattery: 3,
    MaxHoles: 4,
  };

  let messageResponse = {
    None: 0,
    Ok: 1,
    Yes: 2,
    No: 3,
  };

  let messageResponseText = function (response) {
    switch (response) {
      case messageResponse.None:
        return "-";
      case messageResponse.Ok:
        return "Ok";
      case messageResponse.Yes:
        return "Yes";
      case messageResponse.No:
        return "No";
      default:
        return "?";
    }
  };

  async function refresh() {
    let tempStartDate = moment(startDate)
      .utcOffset(-siteSettingsData?.TimeZoneOffset)
      .startOf("day");

    let tempEndDate = moment(endDate)
      .add(1, "days")
      .utcOffset(-siteSettingsData?.TimeZoneOffset)
      .startOf("day");

    setMessageStatus(true);

    let res = await getMessagesHistory(
      siteId.get(),
      tempStartDate.format(),
      tempEndDate.format(),
      headersConfigData
    );

    let resJ = await res.json();
    setMessagesHistoryData(resJ);
    setMessageStatus(false);
  }

  function messageIsDiagnostic(msg) {
    return msg.Text.indexOf("z1lk3r") >= 0 || msg.Text.indexOf("v1s*g3") >= 0;
  }

  var sentString = function (message) {
    var sent = moment.utc(message.Created);
    if (siteSettingsData) sent.utcOffset(-siteSettingsData?.TimeZoneOffset); // convert to course's timezone for display here

    return sent.format("DD-MMM-YYYY hh:mm a");
  };

  function addProperties() {
    let i;
    for (i = 0; i < messagesList?.length; i++) {
      messagesList[i].IsBroadcast = false; // add properties to all the messages
      messagesList[i].IsDuplicate = false;
      if (messageIsDiagnostic(messagesList[i])) {
        messagesList[i].IsDiagnostic = true;
        messagesList[i].Text = messagesList[i].Text.replace(
          "z1lk3r -",
          ""
        ).replace("v1s*g3 -", "");
        messagesList[i].icon = "fa-stethoscope";
      } else {
        messagesList[i].IsDiagnostic = false;
        messagesList[i].icon = "";
      }
    }

    // Now set IsBroadcast true on initial message in a broadcast group,
    // and IsDuplicate on subsequent messages within the group
    i = 1;
    while (i < messagesList?.length) {
      let a = messagesList[i - 1];
      let b = messagesList[i];
      if (b.ToCar && a.ToCar && a.CarNum !== b.CarNum && a.Text === b.Text) {
        let ca = moment(a.Created);
        let cb = moment(b.Created);
        if (ca.add(5, "s").isAfter(cb)) {
          if (!a.IsDuplicate) a.IsBroadcast = true;
          b.IsDuplicate = true;
        }
      }
      i++;
    }
  }
  addProperties();

  function compare(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  let textFilter = messageTextFilter;

  function passesFilters(msg) {
    let cn = parseInt(carsFilter.trim());
    var txt = textFilter.trim().toUpperCase();
    if (!msg?.IsBroadcast && !msg?.IsDuplicate) {
      if (showMemberCars && !validateCarType(msg?.CarNum, updatedCarData.get()))
        return false;
    }
    if (!showMaxHolesNotifications && msg?.MessageType === messageTypes.MaxHoles)
      return false;
    if (
      !(siteSettingsData?.Features?.indexOf(featureKey.power) >= 0) &&
      !showBatteryNotifications &&
      msg?.MessageType === messageTypes.LowBattery
    )
      return false;
    if (!showAZNotifications && msg?.MessageType === messageTypes.ActionZone)
      return false;
    if (
      !(siteSettingsData?.Features?.indexOf(featureKey.power) >= 0) &&
      !showCritFaultNotifications &&
      msg?.MessageType === messageTypes.CriticalFault
    )
      return false;
    if (!showDiagnostics && msg?.IsDiagnostic) { console.log(`Message from car ${msg.CarNum} is diagnostic`); return false; }
    if (cn && cn !== msg?.CarNum && cn !== msg?.ForwardedFrom) return false;
    if (showBroadcast && msg?.IsDuplicate && !cn) return false;
    if (txt && msg.Text.toUpperCase().indexOf(txt) < 0) return false;
    if (showToCar && msg?.ToCar && !msg?.ForwardedFrom) return true;
    if (showForwarded && msg?.ForwardedFrom) return true;
    if (showFromCar && !msg?.ToCar) return true;
    return false;
  }
  const showToCars = (msg) => {
    if (showToCar && msg.ToCar && !msg.ForwardedFrom) return true;
  };

  const showForward = (msg) => {
    if (showForwarded && msg.ForwardedFrom) return true;
  };

  const showFromCars = (msg) => {
    if (showFromCar && !msg.ToCar) return true;
  };

  const showBroadcastMessages = (msg) => {
    let cn = parseInt(carsFilter.trim());
    if (showBroadcast && msg.IsDuplicate && !cn) return false;
  };

  let deliveredString = function (message) {
    if (message.ToCar) {
      if (message.Delivered) return t("Delivered");
      let now = moment.utc();
      if (now.isAfter(moment.utc(message.Expires))) return t("Failed");
      return t("Pending");
    }
    return "-";
  };

  let responseString = function (message) {
    if (!message?.ToCar) return messageResponseText(message?.Response);
    return ""; // blank for messages TO car
  };

  let holeString = function (message) {
    if (!message?.ToCar) {
      if (
        siteSettingsData?.Courses?.length > 1 &&
        message?.Course &&
        message?.Hole
      ) {
        return message?.Course + message?.Hole.toString();
      } else if (message?.Hole) {
        return message?.Hole.toString();
      } else return "-";
    }
    return "";
  }

  const showAsterisk = (msg) => {
    if (!carsFilter && msg?.IsBroadcast && showBroadcast) return <StarIcon style={{ marginTop: 5 }} />;
  }

  function sortAndFilter() {
    if (!Array.isArray(messagesList)) {
      messagesList = [];
      filteredCount = 0;
      return;
    }

    messagesList.sort((a, b) => compare(a.created, b.created));

    let filtered = [];
    let fcount = 0;

    for (let i = 0; i < messagesList.length; i++) {
      let msg = messagesList[i];

      if (enableMemberCar || validateCarType(msg?.CarNum, updatedCarData.get())) {
        const passed = passesFilters(msg);

        if (passed) {
          filtered.push(msg);
        } else {
          // ignore search text from hidden counter
          const isHiddenBySearch =
            messageTextFilter.trim() &&
            msg?.Text?.toUpperCase().indexOf(
              messageTextFilter.trim().toUpperCase()
            ) < 0;

          if (!isHiddenBySearch) {
            fcount++;
          }
        }
      }
    }
    messagesList = filtered;
    filteredCount = fcount;
  }

  sortAndFilter();
  const getRowHeight = (params) => {
    const content = `${params?.model?.text}`;
    return content.length > 100 ? 100 : 50;
  }
  const columns = [
    {
      field: "received",
      headerName: t("Sent/Received"),
      headerClassName: "received-column display",
      minWidth: 200,
      align: "left",
      flex: 1,

      renderCell: (params) => {
        return (
          <div className="super-time-theme--cell received-column ">
            <TimeIcon color="#0009" width={13} height={13} />
            <span>{sentString(params?.row)}</span>
          </div>
        );
      },
    },

    {
      field: "car",
      headerName: t("Car"),
      headerClassName: "lastcolumnSeparator",
      width: 130,
      renderCell: (params, index) => {
        return (
          <div key={index} style={{ display: "flex", gap: "5px" }} className="cars-cell">
            <span>
              {showForward(params?.row) ?
                <p>
                  {params?.row?.ForwardedFrom} <ArrowRightIcon style={{ color: '#a75c00' }} /> <MarshalsCarIcon />
                </p>
                : ""
              }

              {showToCars(params?.row) ?
                <span style={{ marginTop: 5 }}>
                  <span style={{ marginTop: 10 }}><HomeIcon width={12} height={12} color="blue" /></span>
                  <ArrowRightIcon style={{ color: 'blue' }} /></span>
                : ""}
            </span>

            <span style={{ marginTop: 8 }}>
              {!carsFilter && params?.row?.IsBroadcast && showBroadcast ? "" : params?.row?.CarNum}
            </span>

            <span>
              {showFromCars(params?.row) ?
                <span style={{ marginTop: 5 }}><ArrowRightIcon style={{ color: '#a75c00' }} />
                  <HomeIcon color="#a75c00" style={{ marginTop: 10 }} /> </span>
                : ""}
              {showBroadcastMessages(params?.row) ? <CarToAllMsg style={{ marginTop: 5 }} /> : ""}
              {<span style={{ marginTop: 10 }}>{showAsterisk(params?.row)}</span>}
            </span>
          </div>
        );
      },
    },
    {
      field: "text",
      headerName: t("Text"),
      minWidth: 220,
      headerClassName: "lastcolumnSeparator flex-1 for-show-more",
      cellClassName: "word-wrap",
      flex: 3,
      renderCell: (params, index) => {
        function renderMessageTypeIcon() {
          if (params?.row?.MessageType) {
            if (params?.row?.MessageType === 1) {
              return <WarningIcon key={index} />;
            } else if (params?.row?.MessageType === 2) {
              return <ErrorIcon key={index} />;
            } else if (params?.row?.MessageType === 3) {
              return <Battery0BarIcon key={index} />;
            } else if (params?.row?.MessageType === 4) {
              return <SportsScoreIcon key={index} />;
            } else {
              return <></>;
            }
          }
        }
        return (
          <div
            className={
              !showMore[params.row.Id]
                ? "text-cell-inner-data dot-add"
                : "text-cell-inner-data"
            }
          >
            <div
              ref={outerW}
              className={
                !showMore[params.row.Id]
                  ? "inner-div inner-dot-add"
                  : "inner-div"
              }
            >
              <p ref={innerW}>
                {renderMessageTypeIcon()}
                {decodeHtml(params?.row?.Text)}
              </p>

              {showForward(params?.row) ? (
                <p style={{ fontStyle: "italic", color: "#808080" }}>
                  {t("Forwarded_to_marshals_from_car")}
                  {` ${params?.row?.ForwardedFrom}`}
                </p>
              ) : (
                ""
              )}

              {params.row.Text.length > 15 ? (
                <button
                  className="show-more-btn"
                  onClick={() => {
                    setShowMore({
                      ...showMore,
                      [params.row.Id]: !showMore[params.row.Id],
                    });
                  }}
                >
                  {showMore[params.row.Id] ? "Show less" : "Show more"}
                </button>
              ) : (
                ""
              )}
            </div>
          </div>
        );
      },
    },
    {
      field: "response",
      headerName: t("Response"),
      width: 150,
      headerClassName: "lastcolumnSeparator",
      renderCell: (params, index) => {
        return (
          <div key={index} style={{ display: "grid" }}>
            <span>{responseString(params?.row)}</span>
          </div>
        );
      },
    },
    {
      field: "hole",
      headerName: t("Hole"),
      width: 150,
      headerClassName: "lastcolumnSeparator",
      cellClassName: "word-wrap",
      renderCell: (params, index) => {
        return (
          <div key={index} style={{ display: "grid" }}>
            <span>{holeString(params?.row)}</span>
          </div>
        );
      },
    },
    {
      field: "status",
      headerName: t("Status"),
      type: "letter",
      width: 150,
      headerClassName: "lastcolumnSeparator",
      renderCell: (params, index) => {
        return (
          <div key={index} style={{ display: "grid" }}>
            <span>{deliveredString(params?.row)}</span>
          </div>
        );
      },
    },

    {
      field: "sentBy",
      headerName: t("Sent_by"),
      type: "letter",
      minWidth: 200,
      headerClassName: "lastcolumnSeparator",
      renderCell: (params, index) => {
        return (
          <div key={index} style={{ display: "grid" }}>
            <span>{params?.row.SentBy}</span>
          </div>
        );
      },
    },
  ];

  const dateChecker = (newValue, dateDetector) => {
    if (dateDetector === "startDate") {
      if (newValue && newValue.format() !== "Invalid Date") {
        if (startDate && endDate) {
          var date = new Date(newValue);
          var startDateValue = new Date(
            date.getTime() - date.getTimezoneOffset() * 60000
          )
            .toISOString()
            .split("T");

          var date2 = new Date(endDate);
          var endDateValue = new Date(
            date2.getTime() - date2.getTimezoneOffset() * 60000
          )
            .toISOString()
            .split("T");

          if (startDateValue[0] > endDateValue[0]) {
            localStorage.setItem("startDate", new Date(newValue));
            localStorage.setItem("endDate", new Date(newValue));
            setStartDate(new Date(newValue));
            setEndDate(new Date(newValue));
          } else {
            localStorage.setItem("startDate", new Date(newValue));
            setStartDate(new Date(newValue));
          }
        } else {
          if (endDate) {
            var date = new Date(newValue); // Or the date you'd like converted.
            var startDateValue = new Date(
              date.getTime() - date.getTimezoneOffset() * 60000
            )
              .toISOString()
              .split("T");

            var date2 = new Date(endDate); // Or the date you'd like converted.
            var endDateValue = new Date(
              date2.getTime() - date2.getTimezoneOffset() * 60000
            )
              .toISOString()
              .split("T");

            if (startDateValue[0] > endDateValue[0]) {
              localStorage.setItem("startDate", new Date(newValue));
              localStorage.setItem("endDate", new Date(newValue));
              setStartDate(new Date(newValue));
              setEndDate(new Date(newValue));
            } else {
              localStorage.setItem("startDate", new Date(newValue));
              setStartDate(new Date(newValue));
            }
          } else {
            localStorage.setItem("startDate", new Date(newValue));
            setStartDate(new Date(newValue));
          }
        }
      } else {
        if (newValue === null) {
          let sDateData = new Date(localStorage.getItem("startDate"));
          setStartDate(sDateData);
        }
      }
    } else {
      if (newValue && newValue.format() !== "Invalid Date") {
        if (endDate && startDate) {
          var date = new Date(startDate); // Or the date you'd like converted.
          var startDateValue = new Date(
            date.getTime() - date.getTimezoneOffset() * 60000
          )
            .toISOString()
            .split("T");

          var date2 = new Date(newValue); // Or the date you'd like converted.
          var endDateValue = new Date(
            date2.getTime() - date2.getTimezoneOffset() * 60000
          )
            .toISOString()
            .split("T");

          if (startDateValue[0] > endDateValue[0]) {
            localStorage.setItem("startDate", new Date(newValue));
            localStorage.setItem("endDate", new Date(newValue));
            setStartDate(new Date(newValue));
            setEndDate(new Date(newValue));
          } else {
            localStorage.setItem("endDate", new Date(newValue));
            setEndDate(new Date(newValue));
          }
        } else {
          if (startDate) {
            var date = new Date(startDate); // Or the date you'd like converted.
            var startDateValue = new Date(
              date.getTime() - date.getTimezoneOffset() * 60000
            )
              .toISOString()
              .split("T");

            var date2 = new Date(newValue); // Or the date you'd like converted.
            var endDateValue = new Date(
              date2.getTime() - date2.getTimezoneOffset() * 60000
            )
              .toISOString()
              .split("T");

            if (startDateValue[0] > endDateValue[0]) {
              localStorage.setItem("startDate", new Date(newValue));
              localStorage.setItem("endDate", new Date(newValue));
              setEndDate(new Date(newValue));
              setStartDate(new Date(newValue));
            } else {
              localStorage.setItem("endDate", new Date(newValue));
              setEndDate(new Date(newValue));
            }
          } else {
            localStorage.setItem("endDate", new Date(newValue));
            setEndDate(new Date(newValue));
          }
        }
      } else {
        if (newValue === null) {
          let eDateData = new Date(localStorage.getItem("endDate"));
          setEndDate(eDateData);
        }
      }
    }
  };
  return (
    <HistoryContainer>
      <Header className="display">
        <Tooltip title={t("Filter_by_car_number")}>
          <div>
            <SearchWrapper>
              <input
                type="text"
                placeholder="Car no."
                value={searchInputValue}
                onChange={(e) => setSearchInputValue(e.target.value)}
              />
              <img src={SearchIcon} alt="search-icon" />
            </SearchWrapper>
          </div>
        </Tooltip>

        <DateRangePickerWrapper>
          <p className="label">{t("Start")}</p>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              inputFormat="DD-MMM-YYYY"
              selectsEnd
              value={startDate}
              className="test"
              onChange={(newValue) => {
                dateChecker(newValue, "startDate");
              }}
              renderInput={(params) => <TextField {...params} />}
              PaperProps={{
                sx: {
                  maxHeight: 350,
                  "& .MuiPickersLayout-contentWrapper": {
                    mb: 0,
                  }
                }
              }}
              components={{
                ActionBar: (props) => (
                  <TodayDateActionBar
                    {...props}
                    onToday={() => {
                      const today = moment().startOf("day");
                      dateChecker(today, "startDate");
                      props.onAccept?.();
                      props.onClose?.();
                    }}
                  />
                ),
              }}
            />
          </LocalizationProvider>

          <p className="label">{t("End")}</p>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              className="test"
              inputFormat="DD-MMM-YYYY"
              value={endDate}
              onChange={(newValue) => {
                dateChecker(newValue, "endDate");
              }}
              renderInput={(params) => <TextField {...params} />}
              PaperProps={{
                sx: {
                  maxHeight: 350,
                  "& .MuiPickersLayout-contentWrapper": {
                    mb: 0,
                  }
                }
              }}
              components={{
                ActionBar: (props) => (
                  <TodayDateActionBar
                    {...props}
                    onToday={() => {
                      const today = moment().startOf("day");
                      dateChecker(today, "endDate");
                      props.onAccept?.();
                      props.onClose?.();
                    }}
                  />
                ),
              }}
            />
          </LocalizationProvider>
        </DateRangePickerWrapper>
        <Tooltip title={t("Refresh")}>
          <div>
            <button
              className="refresh-btn"
              onClick={refresh}
            >
              <ResendIcon className={messageStatus ? "rotate" : ""} />
            </button>
          </div>
        </Tooltip>
        <div>
          <Tooltip title={t("Show_messages_to_cars")}>
            <div>
              <ClubToCarMsgIcon
                onClick={() => setShowToCar(!showToCar)}
                color={
                  showToCar
                    ? "var(--theme-background)"
                    : "var(--input-background)"
                }
              />
            </div>
          </Tooltip>
          <Tooltip title={t("Show_messages_from_cars")}>
            <div>
              <CarToClubMsgIcon
                onClick={() => setShowFromCar(!showFromCar)}
                color={
                  showFromCar
                    ? "var(--theme-background)"
                    : "var(--input-background)"
                }
              />
            </div>
          </Tooltip>
          <Tooltip title={t("Show_messages_forwarded_to_marshal(s)")}>
            <div>
              <CarToMarshalCarMsg
                onClick={() => setShowForwarded(!showForwarded)}
                color={
                  showForwarded
                    ? "var(--theme-background)"
                    : "var(--input-background)"
                }
              />
            </div>
          </Tooltip>
        </div>
        <div>
          <Tooltip title={t("Group_broadcast_messages_together")}>
            <div>
              <CarToAllMsg
                onClick={() => setShowBroadcast(!showBroadcast)}
                color={
                  showBroadcast
                    ? "var(--theme-background)"
                    : "var(--input-background)"
                }
              />
            </div>
          </Tooltip>
        </div>
        <div>
          <Tooltip title={t("Show_Action_Zone_notifications")}>
            <div>
              <ExclamationMarkTrangel
                onClick={() => setShowAZNotifications(!showAZNotifications)}
                color={showAZNotifications ? "var(--theme-background)" : "none"}
                fill="var(--input-background)"
                stroke="var(--input-background)"
              />
            </div>
          </Tooltip>
          <Tooltip title={t("Show_Car_Fault_notifications")}>
            <div>
              <ExclamationMarkIcon
                onClick={() =>
                  setShowCritFaultNotifications(!showCritFaultNotifications)
                }
                color={
                  showCritFaultNotifications
                    ? "var(--theme-background)"
                    : "none"
                }
                fill="var(--input-background)"
                stroke="var(--input-background)"
              />
            </div>
          </Tooltip>
          <Tooltip title={t("Show_Low_Battery_notifications")}>
            <div>
              <BatteryIcon
                onClick={() =>
                  setShowBatteryNotifications(!showBatteryNotifications)
                }
                color={
                  showBatteryNotifications ? "var(--theme-background)" : "none"
                }
                fill="var(--input-background)"
                stroke="var(--input-background)"
              />
            </div>
          </Tooltip>
          <Tooltip title={t("Show_Max_Holes_notifications")}>
            <div>
              <FilterFlagIcon
                onClick={() =>
                  setShowMaxHolesNotifications(!showMaxHolesNotifications)
                }
                color={
                  showMaxHolesNotifications ? "var(--theme-background)" : "none"
                }
                fill="var(--input-background)"
                stroke="var(--input-background)"
              />
            </div>
          </Tooltip>
          {enableMemberCar &&
            <Tooltip title={t("Show_member_cars")}>
              <div>
                <MembercarIcon
                  onClick={() =>
                    setShowMemberCars(!showMemberCars)
                  }
                  width={30}
                  height={30}
                  bg={showMemberCars ? "transparent" : "var(--theme-background)"}
                  color={showMemberCars ? "var(--input-background)" : "white"}
                  stroke="var(--input-background)"
                />

              </div>
            </Tooltip>}
          {(isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role)) &&
            <Tooltip title={t("Show_diagnostics_messages")}>
              <div>
                <DiagnosticsIcon
                  bg={showDiagnostics ? "#4f8edc" : "#b7e0f4"}
                  stroke={showDiagnostics ? "#ffffff" : "#ffffff"}
                  color={showDiagnostics ? "white" : "#585757"}
                  onClick={() => setShowDiagnostics(prev => !prev)}
                />
              </div>
            </Tooltip>}
        </div>
        {(isUserAdmin(getUserRole?.Role) ||
          isUserSupport(getUserRole?.Role)) && (
            <div style={{ marginRight: "10px" }}>
              <TextField
                size="small"
                placeholder="Search by text..."
                value={messageTextFilter}
                onChange={(e) => setMessageTextFilter(e.target.value)}
                variant="outlined"
                sx={{
                  width: 170,
                  backgroundColor: "#fff",
                  "& .MuiOutlinedInput-root": {
                    height: "34px",
                    "& fieldset": {
                      borderColor: "#AEAEAe",
                    },
                    "&:hover fieldset": {
                      borderColor: "#9e9e9e",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#9e9e9e",
                    },
                  },
                  borderRadius: 2
                }}
              />
              <Tooltip title={t("Number_of_messages_hidden_by_filters")} style={{
                display: "inline-flex",
                alignItems: "center",
              }}>
                <div className="filter-icon">
                  <FilterAltIcon color="#fff" />
                  <p>{filteredCount}</p>
                </div>
              </Tooltip>
            </div>
          )}

      </Header>

      <MobileHeader>
        <h4>History</h4>
        <IconButton>
          <ThreeDotIcon
            color="#fff"
            width={3.19}
            height={14.36}
            onClick={() => setThreeDotState(!threeDotState)}
          />
        </IconButton>
        {threeDotState && (
          <div className="open-section">
            <Header>
              <Tooltip title={t("Filter_by_car_number")}>
                <div>
                  <SearchWrapper>
                    <input
                      type="text"
                      placeholder="Car no."
                      value={searchInputValue}
                      onChange={(e) => setSearchInputValue(e.target.value)}
                    />
                    <img src={SearchIcon} alt="search-icon" />
                  </SearchWrapper>
                </div>
              </Tooltip>
              <DateRangePickerWrapper>
                <p className="label">{t("Start")}</p>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    inputFormat="DD-MMM-YYYY"
                    selectsEnd
                    value={startDate}
                    className="test"
                    onChange={(newValue) => {
                      dateChecker(newValue, "startDate");
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
                <p className="label">{t("End")}</p>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className="test"
                    inputFormat="DD-MMM-YYYY"
                    value={endDate}
                    onChange={(newValue) => {
                      dateChecker(newValue, "endDate");
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </DateRangePickerWrapper>
              <Tooltip title={t("Refresh")}>
                <div>
                  <button className="refresh-btn" onClick={refresh}>
                    <ResendIcon />
                  </button>
                </div>
              </Tooltip>

              <div>
                <Tooltip title={t("Show_messages_to_cars")}>
                  <div>
                    <ClubToCarMsgIcon
                      onClick={() => setShowToCar(!showToCar)}
                      backgroundColor="blue"
                      color={
                        showToCar
                          ? "var(--theme-background)"
                          : "var(--input-background)"
                      }
                    />
                  </div>
                </Tooltip>
                <Tooltip title={t("Show_messages_from_cars")}>
                  <div>
                    <CarToClubMsgIcon
                      onClick={() => setShowFromCar(!showFromCar)}
                      color={
                        showFromCar
                          ? "var(--theme-background)"
                          : "var(--input-background)"
                      }
                    />
                  </div>
                </Tooltip>
                <Tooltip title={t("Show_messages_forwarded_to_marshal(s)")}>
                  <div>
                    <CarToMarshalCarMsg
                      onClick={() => setShowForwarded(!showForwarded)}
                      color={
                        showForwarded
                          ? "var(--theme-background)"
                          : "var(--input-background)"
                      }
                    />
                  </div>
                </Tooltip>

                <Tooltip title={t("Group_broadcast_messages_together")}>
                  <div>
                    <CarToAllMsg
                      onClick={() => setShowBroadcast(!showBroadcast)}
                      color={
                        showBroadcast
                          ? "var(--theme-background)"
                          : "var(--input-background)"
                      }
                    />
                  </div>
                </Tooltip>
              </div>
              <div>
                <Tooltip title={t("Show_Action_Zone_notifications")}>
                  <div>
                    <ExclamationMarkTrangel
                      onClick={() =>
                        setShowAZNotifications(!showAZNotifications)
                      }
                      color={
                        showAZNotifications ? "var(--theme-background)" : "none"
                      }
                      fill="var(--input-background)"
                      stroke="var(--input-background)"
                    />
                  </div>
                </Tooltip>
                <div>
                  <ExclamationMarkIcon
                    onClick={() =>
                      setShowCritFaultNotifications(!showCritFaultNotifications)
                    }
                    color={
                      showCritFaultNotifications
                        ? "var(--theme-background)"
                        : "none"
                    }
                    fill="var(--input-background)"
                    stroke="var(--input-background)"
                  />
                </div>
                <Tooltip title={t("Show_Low_Battery_notifications")}>
                  <div>
                    <BatteryIcon
                      onClick={() =>
                        setShowBatteryNotifications(!showBatteryNotifications)
                      }
                      color={
                        showBatteryNotifications
                          ? "var(--theme-background)"
                          : "none"
                      }
                      fill="var(--input-background)"
                      stroke="var(--input-background)"
                    />
                  </div>
                </Tooltip>
                <Tooltip title={t("Show_Max_Holes_notifications")}>
                  <div>
                    <FilterFlagIcon
                      onClick={() =>
                        setShowMaxHolesNotifications(!showMaxHolesNotifications)
                      }
                      color={
                        showMaxHolesNotifications
                          ? "var(--theme-background)"
                          : "none"
                      }
                      fill="var(--input-background)"
                      stroke="var(--input-background)"
                    />
                  </div>
                </Tooltip>
                {enableMemberCar &&
                  <Tooltip title={t("Show_member_cars")}>
                    <div>
                      <MembercarIcon
                        onClick={() =>
                          setShowMemberCars(!showMemberCars)
                        }
                        width={30}
                        height={30}
                        bg={showMemberCars ? "transparent" : "var(--theme-background)"}
                        color={showMemberCars ? "var(--input-background)" : "white"}
                        stroke="var(--input-background)"
                      />
                    </div>
                  </Tooltip>
                }
              </div>
            </Header>
          </div>
        )}
      </MobileHeader>

      <TableContainer className="history-table">
        <BodyWrapper>
          <HistoryTableInnerSection className="no-pagination">
            <DataGrid
              components={{
                NoRowsFlay: () => (
                  <Stack
                    height="100%"
                    alignItems="center"
                    justifyContent="center"
                  >
                    {t("No_data")}
                  </Stack>
                ),
              }}
              rows={messagesList}
              columns={columns}
              getRowHeight={getRowHeight}
              disableSelectionOnClick
              disableColumnMenu
              sortingOrder={["asc", "desc"]}
              getRowId={(row) => row.id}
            />
          </HistoryTableInnerSection>
        </BodyWrapper>
      </TableContainer>
    </HistoryContainer>
  );
};
